import React from "react";
import { renderRichText } from "gatsby-source-storyblok";
import { Href } from "../utils/helper";


const FlightSideAd = ({ blok }) => {
  // console.log(blok)

  return (
    <div className="m-4 xl:max-w-[475px]">
      <a href={Href(blok.sideAdUrl)}>
        { blok.sideAdImage?.filename && <img className="max-w-full h-auto rounded object-contain object-center" 
          loading="lazy" src={blok.sideAdImage.filename} alt={blok.sideAdImage.alt} /> }
      </a>
        <div className="p-4" dangerouslySetInnerHTML={{ __html: renderRichText(blok.sideAdText) }}  />
    </div>
  );
};

export default FlightSideAd;
